import { DatePicker, DateTimePicker, TimePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { ModelSavingData } from "src/hooks/use-model-saving-data";

export type TruxDateTimeFieldProps<T> = {
  modelSavingData: ModelSavingData<T>,
  field: keyof T,
  label?: string,
  disabled?: boolean,
  limitWidth?: boolean,
  timezone: string,
}

export default function TruxDateTimeField<T>({ modelSavingData, field, timezone, disabled = false, label, limitWidth = true }: TruxDateTimeFieldProps<T>) {
  const value = modelSavingData.model?.[field] as string;
  return <DateTimePicker
    views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
    label={label}
    timezone={timezone}
    value={!value ? null : dayjs(value).tz(timezone)}
    onChange={(date) => { modelSavingData.update(model => { model[field] = date?.format() as any }) }}
    disabled={disabled}
    slotProps={{
      textField: {
        fullWidth: true,
        size: "small"
      },
    }}
    sx={{
      maxWidth: limitWidth ? { md: 180 } : undefined,
      width: "100%"
    }}
  />
}